import { useSelector } from 'react-redux';
import { selectTitleCheckResponse } from '../../redux-state/selectors';
import ReportDialog from '../common/reportDialog';
import TitleOutputRightSide from './TitleOutputRightSide';

function TitleCheckReportDialog({ open, onClose, onNext, nextButton }) {
  const titleCheckResponse = useSelector(selectTitleCheckResponse);
  const { vehicle_info } = titleCheckResponse? titleCheckResponse : {} ;

  const content = (
    <div className="overflow-y-auto scrollbar-hide">
      <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
        <div className="text-gray-700 mb-3">
          <span className='text-gray-700 text- font-bold'> Vehicle Information </span>
          <span className='text-xs text-gray-600'>{vehicle_info?.vinCode}</span>
        </div>

        <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-24">
          <div className="flex flex-col w-[100%] text-gray-700 gap-2">
            {vehicle_info?.year &&
              <div className="flex flex-row justify-between">
                <div>Year:</div>
                <div className="font-medium">{vehicle_info?.year}</div>
              </div>
            }

            {vehicle_info?.make &&
              <div className="flex flex-row justify-between">
                <div>Make & Model:</div>
                <div className="font-medium">{vehicle_info?.make} , {vehicle_info?.model}</div>
              </div>
            }
          </div>
        </div>
      </div>
      <TitleOutputRightSide />
    </div>
  );

  const footerProps = {
    primaryButton: {
      text: nextButton,
      width: '120px',
      height: '50px',
    },
    secondaryButton: {
      text: "Quit",
      width: '120px',
      height: '50px',
    },
  };

  return (
    <ReportDialog
      title={"Lien & Title Report"}
      open={open}
      text="text-3xl font-semibold"
      fullScreen={false}
      maxWidth="md"
      content={content}
      onClose={onClose}
      onSubmit={onNext}
      footerProps={footerProps}
    />
  );
}

export default TitleCheckReportDialog;
